export const EmptyId: string = "000000000000000000000000";
export const EmptyESId: string = "00000000000000000000";

export enum BusyEvent {
    LoadCategories = 0x01,
    LoadFeaturedOps = 0x02,
    LoadRecommendedOps = 0x04,
    LoadCategoryOps = 0x08,
    LoadOpportunity = 0x10,
    LoadRelatedOps = 0x20,
    LoadProfile = 0x40,
    ScoreOpportunities = 0x80,
    ParseResume = 0x100,
    SubmitApplication = 0x200,
    LoadCourses = 0x400,
    GeneratingProfile = 0x800,
    SearchingOpportunities = 0x1000,
    GeneratingNonSpecificProfile = 0x2000,
    SubmittingHelp = 0x4000,
}

export enum ScreenMode {
  Mobile,
  Tablet,
  Desktop
}

export enum View {
  Undefined = -1,
  Opportunities = 0,
  Profile = 1,
  Eligibility = 2,
  // add other enumerations as the primary views/tabs are defined
}

export enum ProfileView {
  Skills = 1,
  Experience = 2
}

export enum ProfileViewState {
  SkillsView = 0,
  ExperienceView = 1
}

export enum ProfileSkillState {  
  UpdateSkillView = 0,
  SkillsToExpView = 1,
  AddSkillView = 2,
  NoSelection = 3
}

export enum OpportunityViewState {
  NotSelected = 0,
  SkillsView = 1,
  ExperienceView = 2,
  BuildView = 3
}

export enum StatusFlag {
  Active = 1,
  Disabled = 4
}

export enum ExperienceType {
  NotSpecified = 0,
  Work = 1,
  Military = 2,
  Life = 3,
  GEDDegree = 4,
  Course = 5,
  Language = 6,
  CCLC = 7
}

export enum CCLCRefType {
  Certification = 1,
  Certificate = 2,
  License = 3,
  Card = 4,
  Badge = 5,
  Credential = 6
};

export enum LookupType {
    Unknown = 0,
    Ethnicity = 1,
    EmploymentStatus = 2,
    EducationLevel = 3,
    Country = 4,
    StateProv = 5,
    LifeEventTimeseries = 6,
    UseFrequency = 7,
    PrerequisiteType = 8,
    Language = 9,
    PositionType = 10,
    HowHeard = 11,
    VetStatus = 12,
    PrereqAssertions = 13,
    GEDUse = 14,
    SchoolUse = 15,
    Gender = 16,
    ContactReason = 17,
    CourseUse = 18,
    LifeEventStatic = 19,
    Services = 20,
    ServiceTypes = 21,
    Ranks = 22,
    RanksAirForce = 23,
    RanksArmy = 24,
    RanksCoastGuard = 25,
    RanksMarines = 26,
    RanksNavy = 27,
    Industry = 28,
    Region = 29,
    ReferralOption = 30,
    EntityType = 31,
    WorkType = 32,
    JobCategories = 33,
}

export enum SavedOpportunityState {
  Saved = 0x01,
  Priority = 0x02,
  Applied = 0x04,
  Responded = 0x08,
  Rejected = 0x10,
  Accepted = 0x20,
  Locked = 0x40,
  Unlocked = 0x80,
  Viewed = 0x100
}

export enum SkillLevel {
  Exclude = 0,
  Exposed = 1,
  SomeExperience = 2,
  Competent = 3,
  Proficient = 4,
  Expert = 5
}

export enum ApplicationProcess {
  Unspecified = 0,
  EmailProfile = 1,
  ExternalLink = 2
}

export enum FeatureLevel {
  Primary = 1,
  Secondary = 2,
  Tertiary = 3,
  Detail = 4,
  LandingImage = 5
}

export enum FeatureFilter {
  ShowAlways = 1,
  Anonymous = 2,
  Authenticated = 3,
  LastLoginBefore = 4,
  LastLoginAfter = 5,
  DaysSinceLastLoginGreaterThan = 6,
  FirstLogin = 7,
}

export enum RefType {
  NotSpecified = 0,
  Certification = 1,
  Certificate = 2,
  License = 3,
  Card = 4,
  Badge = 5,
  Credential = 6
}

export enum OperatorType {
  FIELD = 0,
  AND = 1,
  OR = 2,
}

export enum PrereqType {
  Education = 1,
  CCLC = 2,
  Acceptance = 3,
  Age = 4
}

export enum CCLCFieldMask {
  ReceiptDate = 1,
  ExpireDate = 2,
  Issuer = 4,
  Number = 8,
  Acceptance = 16,
  Score = 32
}

export enum PositionLevel {
  NotSpecified = 0,
  Entry = 1,
  Mid = 2,
  Experienced = 3
}

export enum JobType {
  Unknown = 0,
  Work = 1,
  Military = 2,
}

export enum EdType {
  Unknown = 0,
  DegreeProgram = 1,
  Course = 2
}

/*Used to track what should be displayed in the experience drop down*/
export enum AddExpRoute {
  All = 0,
  Experience = 1,
  Cclc = 2,
  Lanuage = 3,
  Apply = 4
}

/*Used to track what validation is needed for certificates*/
export enum CertValidation {
  None = 0,
  DateRecieved = 1,
  DateExpired = 2,
  FullDate = 3
}

export enum SkillSmartProduct {
  NotSet = 0,
  Curation = 1,
  Insight = 2,
  Prospect = 3,
  Seeker = 4
}

export enum HelpRequestPriority {
  NA = 0,
  Low = 1,
  Medium = 2,
  High = 3,
  Critical = 4
}


// WEBPACK FOOTER //
// ./src/models/enums.ts